import { useEffect } from 'react';
import '@Css/App.css';
import { Provider } from 'react-redux';
import { MemoryRouter as Router } from "react-router-dom";
import { store } from '@Store';
import HandleRoute from '@Route';
import Toast from'@Toast';
import Cookies from 'js-cookie';

function App() {

  useEffect(() => {
    // Test Cookie 'json'
    /*const obj = {
      authToken: "eyAiYWxnIjoiSFMyNTYiLCAidHlwIjoiSldUIiB9.eyAiaWF0IjoxNzUwOTUyNTY5LCAiZXhwIjoxNzUwOTUyNTY5LCAibWVtYmVyX2lkIjozNDggfQ==#Lp90ZBCK-Y7dP5uAy0cVUzmQC_UWunEVdFVGmYHucGw=",
      firstname: "(Maintenance CRM)",
      lastname: "FORT EMMANUEL",
      idCommercial: 2,
      idAgence: 1,
      idProfil: 256,
      nomAgence: "Olonne sur Mer [85-Vendée]",
      latitudeAgence: 46.5145378,
      longitudeAgence: -1.75966,
      origin: "windev",
      action: "map"
    };
    Cookies.set('json', JSON.stringify(obj));*/
    }, []);
    
  return (
    <Provider store={store}>
        <div className="App">
            <Router>
              <Toast />
              <HandleRoute />
            </Router>
        </div>
    </Provider>
  );
}

export default App;
